<template>
  <div class="rule" style>
    <div class="rule-con">
      <div class="rule-text">
        <div class="text">
          <p v-html="ruleText"></p>
        </div>
      </div>
      <a href="javascript:void(0);" @click="close"></a>
    </div>
  </div>
</template>  

<script>
import Vue from "vue";
import * as URL from "../../assets/js/url.js";
export default {
  props: ["ruleText"],
  data() {
    return {};
  },
  created() {},

  methods: {
    close() {
      this.$emit("isRuleAlert", false);
    }
  }
};
</script>
<style lang="less" scoped>
/* 活动规则 */
.rule,
.redbox {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  z-index: 9999;
}
.rule .rule-con {
  width: 88.33%;
  max-width: 625px;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.rule .rule-con .rule-text {
  font-family: "Microsoft YaHei";
  background-color: #fff;
  height: 7.8rem;
  border-radius: 0.22rem;
  padding: 0.72rem 0.26rem 0.35rem 0.26rem;
  box-sizing: border-box;
  position: relative;
}
.rule .rule-con .rule-text .text {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.rule .rule-con .rule-text p {
  padding-left: 1.6em;
  // text-indent: 1em;
  line-height: 1.62;
  font-size: 0.28rem;
  color: #333;
  margin-bottom: 0.34rem;
}
.rule .rule-con .rule-text:after {
  content: "";
  display: block;
  width: 2.8rem;
  height: 0.64rem;
  background: url(//i0.ulecdn.com/i/event/2018/0511/bargain/ba1.png) no-repeat
    center;
  background-size: 100% 100%;
  position: absolute;
  top: -0.1rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: -1;
}
.rule .rule-con .rule-text:before {
  content: "";
  display: block;
  width: 2.6rem;
  height: 0.64rem;
  background: url(//i0.ulecdn.com/i/event/2018/0511/bargain/ba2.png) no-repeat
    center;
  background-size: 100% 100%;
  position: absolute;
  top: -0.1rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 1;
}
.rule .rule-con a {
  display: block;
  width: 0.8rem;
  height: 0.8rem;
  background: url(//i0.ulecdn.com/i/event/2018/0511/bargain/ba3.png) no-repeat
    center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ruleAlert.vue